import { LocalDate } from '@js-joda/core';
import styled from 'styled-components';

import { AppointmentRecurrenceMonthRecurrenceType } from '@dreryk/egabinet-appointment-frontend-api';

import {
   createSingleInterpolatedTranslationKey,
   FormContextValues,
   InterpolatedTranslationKey,
   useTranslate,
   weekdayLongFormatter,
} from '@dreryk/react-common';
import { Select, StyledFlex } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

const StyledSelect = styled(Select)`
   min-width: 197px;
` as typeof Select;

const RECURRENCE_TYPE_FIELD_NAME = 'recurrenceType';

type RecurrenceListValueType = AppointmentRecurrenceMonthRecurrenceType;
type RecurrenceTypeFieldProps = Pick<FormContextValues<RecurrenceTypeFormBeanPart>, 'register'> & {
   readonly date: LocalDate;
};
type RecurrenceTypeFormBeanPart = {
   [RECURRENCE_TYPE_FIELD_NAME]?: AppointmentRecurrenceMonthRecurrenceType;
};

const getInterpolatedTranslationKey = (
   recurrence: RecurrenceListValueType,
   date?: LocalDate
): InterpolatedTranslationKey => {
   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.create.form.recurrenceType[recurrence],
      'dayName',
      date ? `(${weekdayLongFormatter(date)})` : ''
   );
};

export const RecurrenceTypeField = (props: RecurrenceTypeFieldProps): JSX.Element => {
   const translate = useTranslate();
   const triggerLabelExtractor = (recurrenceType: RecurrenceListValueType): string => {
      return translate(getInterpolatedTranslationKey(recurrenceType, props.date));
   };

   return (
      <StyledFlex>
         <StyledSelect<RecurrenceListValueType>
            triggerLabelExtractor={triggerLabelExtractor}
            label={appointmentsTranslationKeys.create.form.recurrenceType.label}
            controller={props.register(RECURRENCE_TYPE_FIELD_NAME)}
            testId={RECURRENCE_TYPE_FIELD_NAME}
            defaultValue={'SAME_DAY_OF_WEEK'}
         >
            <>
               <Select.Item
                  testId={'SAME_DAY_OF_WEEK'}
                  item={'SAME_DAY_OF_WEEK'}
                  label={getInterpolatedTranslationKey('SAME_DAY_OF_WEEK', props.date)}
               />
               <Select.Item
                  testId={'SAME_DAY_OF_MONTH'}
                  item={'SAME_DAY_OF_MONTH'}
                  label={getInterpolatedTranslationKey('SAME_DAY_OF_MONTH')}
               />
            </>
         </StyledSelect>
      </StyledFlex>
   );
};
